export default __webpack_public_path__ + "static/media/template14.eb81b709.jpg";